// closeModal — its own module so an entry that does not load this whole
// barrel (the comm app, comm/functions.js) registers the SAME dispatcher.
import { closeModal as _closeModalLayer } from '@symbo.ls/windows'

// closeModal — DISPATCHER between the two live modal systems.
//
// This project-level export shadows the @symbo.ls/windows `closeModal`
// arriving via sharedLibraries (project functions win in the merged
// registry), which used to make every windows-layer close that resolved
// through it a SILENT NO-OP — found live 2026-06-10: the meet New-call
// modal stayed open (reset) over the call view because
// `closeNewRoomModal` → `this.call('closeModal', id)` hit this stateKey
// walker instead of the plugin stack. So route explicitly:
//
//   1. id passed            → windows layer (only layer callers pass ids)
//   2. stateKey ancestor    → legacy in-page modal: clear root[stateKey]
//      (+ extraClose), the brand ModalHeader X path for RoomSettings/
//      NewChannel/NewBooking/CreateAgent-style modals
//   3. neither              → windows pop-top (ModalHeader X inside a
//      windows custom-template body)
//
// Guards against ancestors with non-string stateKey or non-object
// extraClose (e.g. reactive factory functions that haven't resolved).
export const closeModal = function (id) {
  if (id) return _closeModalLayer.call(this, id)
  const root = this?.state?.root
  let m = this
  while (m) {
    const sk = typeof m.stateKey === 'string' ? m.stateKey : null
    if (sk) {
      if (!root?.update) return
      const extra =
        m.extraClose && typeof m.extraClose === 'object' && !Array.isArray(m.extraClose)
          ? m.extraClose
          : null
      root.update(extra ? { [sk]: null, ...extra } : { [sk]: null })
      return
    }
    m = m.parent
  }
  return _closeModalLayer.call(this)
}
